import { render, staticRenderFns } from "./RefreshJwtBox.vue?vue&type=template&id=3be5fe4e&scoped=true&"
import script from "./RefreshJwtBox.vue?vue&type=script&lang=js&"
export * from "./RefreshJwtBox.vue?vue&type=script&lang=js&"
import style0 from "./RefreshJwtBox.vue?vue&type=style&index=0&id=3be5fe4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be5fe4e",
  null
  
)

export default component.exports